
import { Link } from 'react-router-dom';

export default function NudgePage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-blue-50 to-sky-50">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-indigo-600 via-blue-600 to-sky-600 text-white py-20">
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
        <div className="container mx-auto px-6 relative z-10">
          <div className="max-w-4xl mx-auto">
            <Link to="/motivation" className="inline-flex items-center text-white/80 hover:text-white mb-6 transition-colors">
              <i className="ri-arrow-left-line mr-2"></i>
              動機付け一覧に戻る
            </Link>
            <div className="inline-flex items-center justify-center w-16 h-16 bg-white/20 backdrop-blur-sm rounded-xl mb-6">
              <i className="ri-hand-heart-line text-4xl"></i>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-4">ナッジ理論</h1>
            <p className="text-xl text-white/90">Nudge Theory</p>
            <p className="text-lg text-white/80 mt-2">提唱者：Thaler & Sunstein</p>
          </div>
        </div>
      </section>

      {/* Core Message */}
      <section className="py-16">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <div className="bg-gradient-to-br from-indigo-500 to-blue-500 rounded-2xl shadow-2xl p-8 md:p-12 text-white text-center">
              <h2 className="text-3xl font-bold mb-4">人は合理的ではなく、環境に流されて行動する</h2>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto space-y-12">
            {/* 理論の概要 */}
            <div className="bg-white rounded-2xl shadow-lg p-8 border border-indigo-100">
              <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                <div className="w-10 h-10 bg-gradient-to-br from-indigo-500 to-blue-500 rounded-lg flex items-center justify-center mr-3">
                  <i className="ri-book-open-line text-xl text-white"></i>
                </div>
                理論の概要
              </h2>
              <p className="text-gray-700 leading-relaxed mb-6">
                ナッジ（Nudge）とは「そっと後押しする」という意味です。人は常に合理的な判断をするわけではなく、環境や状況に大きく影響されます。この特性を活かし、<strong className="text-indigo-600">強制ではなく、環境設計によって望ましい行動を促す</strong>のがナッジ理論です。
              </p>
              <div className="bg-gradient-to-br from-indigo-50 to-blue-50 rounded-xl p-6 border border-indigo-200">
                <h3 className="font-bold text-gray-900 mb-3">ナッジの例</h3>
                <ul className="space-y-2 text-gray-700 text-sm">
                  <li className="flex items-start">
                    <i className="ri-arrow-right-s-line text-indigo-500 mr-2 mt-0.5"></i>
                    <span>カフェテリアで健康的な食品を目の高さに配置する</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-arrow-right-s-line text-indigo-500 mr-2 mt-0.5"></i>
                    <span>臓器提供の同意をデフォルトにする</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-arrow-right-s-line text-indigo-500 mr-2 mt-0.5"></i>
                    <span>階段の近くに「健康のために階段を」と表示する</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* 薬局運営への活用 */}
            <div className="bg-white rounded-2xl shadow-lg p-8 border border-indigo-100">
              <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-indigo-500 rounded-lg flex items-center justify-center mr-3">
                  <i className="ri-hospital-line text-xl text-white"></i>
                </div>
                薬局運営への活用
              </h2>
              <div className="space-y-6">
                <div className="bg-gradient-to-br from-indigo-50 to-blue-50 rounded-xl p-6 border border-indigo-200">
                  <h3 className="text-lg font-bold text-gray-900 mb-3 flex items-center">
                    <i className="ri-user-settings-line text-indigo-600 mr-2"></i>
                    声かけ・施策の属人化防止
                  </h3>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    「あの人は声かけが上手い」「あの人は忘れがち」という属人的な差を、環境設計で解消します。
                  </p>
                  <div className="grid md:grid-cols-2 gap-4">
                    <div className="bg-white rounded-lg p-4 border border-indigo-100">
                      <h4 className="font-bold text-gray-900 mb-2 text-sm">属人化の問題</h4>
                      <ul className="text-xs text-gray-600 space-y-1">
                        <li>・特定の人だけが実施</li>
                        <li>・忘れる人がいる</li>
                        <li>・品質にばらつき</li>
                      </ul>
                    </div>
                    <div className="bg-white rounded-lg p-4 border border-blue-100">
                      <h4 className="font-bold text-gray-900 mb-2 text-sm">ナッジによる解決</h4>
                      <ul className="text-xs text-gray-600 space-y-1">
                        <li>・チェックリストの配置</li>
                        <li>・視覚的なリマインダー</li>
                        <li>・デフォルト設定の活用</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="bg-gradient-to-br from-blue-50 to-sky-50 rounded-xl p-6 border border-blue-200">
                  <h3 className="text-lg font-bold text-gray-900 mb-3 flex items-center">
                    <i className="ri-lightbulb-flash-line text-blue-600 mr-2"></i>
                    「意識改革」に頼らない行動設計
                  </h3>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    「もっと意識を高めて」「気をつけて」という指導は効果が薄いです。代わりに、<strong className="text-blue-600">自然と望ましい行動が取れる環境</strong>を設計します。
                  </p>
                  <div className="space-y-3">
                    <div className="flex items-start p-3 bg-white rounded-lg border border-blue-100">
                      <i className="ri-close-circle-line text-red-500 mr-3 mt-0.5"></i>
                      <div>
                        <span className="text-gray-700 text-sm font-semibold">意識改革アプローチ</span>
                        <p className="text-xs text-gray-500">「手洗いを忘れないように意識して」</p>
                      </div>
                    </div>
                    <div className="flex items-start p-3 bg-white rounded-lg border border-blue-100">
                      <i className="ri-checkbox-circle-line text-green-500 mr-3 mt-0.5"></i>
                      <div>
                        <span className="text-gray-700 text-sm font-semibold">ナッジアプローチ</span>
                        <p className="text-xs text-gray-500">「調剤室入口に手指消毒剤を設置し、通過時に自然と目に入るようにする」</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* 薬局で使えるナッジの例 */}
            <div className="bg-white rounded-2xl shadow-lg p-8 border border-indigo-100">
              <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                <div className="w-10 h-10 bg-gradient-to-br from-indigo-500 to-blue-500 rounded-lg flex items-center justify-center mr-3">
                  <i className="ri-lightbulb-line text-xl text-white"></i>
                </div>
                薬局で使えるナッジの例
              </h2>
              <div className="grid md:grid-cols-2 gap-4">
                <div className="bg-gradient-to-br from-indigo-50 to-blue-50 rounded-xl p-5 border border-indigo-200">
                  <i className="ri-checkbox-multiple-line text-2xl text-indigo-600 mb-3"></i>
                  <h3 className="font-bold text-gray-900 mb-2">チェックリストの配置</h3>
                  <p className="text-sm text-gray-600">作業場所にチェックリストを貼り、自然と確認できるようにする</p>
                </div>
                <div className="bg-gradient-to-br from-blue-50 to-sky-50 rounded-xl p-5 border border-blue-200">
                  <i className="ri-palette-line text-2xl text-blue-600 mb-3"></i>
                  <h3 className="font-bold text-gray-900 mb-2">色分け・視覚化</h3>
                  <p className="text-sm text-gray-600">重要な情報を色分けし、一目で分かるようにする</p>
                </div>
                <div className="bg-gradient-to-br from-sky-50 to-indigo-50 rounded-xl p-5 border border-sky-200">
                  <i className="ri-settings-3-line text-2xl text-sky-600 mb-3"></i>
                  <h3 className="font-bold text-gray-900 mb-2">デフォルト設定</h3>
                  <p className="text-sm text-gray-600">望ましい選択肢をデフォルトに設定する</p>
                </div>
                <div className="bg-gradient-to-br from-indigo-50 to-blue-50 rounded-xl p-5 border border-indigo-200">
                  <i className="ri-map-pin-line text-2xl text-indigo-600 mb-3"></i>
                  <h3 className="font-bold text-gray-900 mb-2">動線設計</h3>
                  <p className="text-sm text-gray-600">自然と望ましい行動が取れる動線を設計する</p>
                </div>
              </div>
            </div>

            {/* 明日の一手 */}
            <div className="bg-gradient-to-br from-indigo-600 via-blue-600 to-sky-600 rounded-2xl shadow-2xl p-8 text-white">
              <h2 className="text-2xl font-bold mb-4 flex items-center">
                <i className="ri-calendar-check-line text-3xl mr-3"></i>
                明日の一手
              </h2>
              <p className="text-lg text-white/90 leading-relaxed mb-6">
                「意識改革」で解決しようとしている課題を、環境設計で解決できないか考えてみましょう。
              </p>
              <div className="bg-white/20 backdrop-blur-sm rounded-xl p-6">
                <p className="text-white font-semibold mb-2">具体的なアクション：</p>
                <p className="text-white/90 leading-relaxed">
                  「忘れがちな作業」を1つ選び、チェックリストの配置や視覚的なリマインダーなど、環境を変えることで解決できないか検討する。
                </p>
              </div>
            </div>

            {/* Navigation */}
            <div className="flex justify-between items-center pt-8 border-t border-gray-200">
              <Link to="/motivation/feedback" className="flex items-center text-indigo-600 hover:text-indigo-700 font-semibold transition-colors">
                <i className="ri-arrow-left-line mr-2"></i>
                フィードバック理論
              </Link>
              <Link to="/motivation/behavioral-economics" className="flex items-center text-indigo-600 hover:text-indigo-700 font-semibold transition-colors">
                行動経済学
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
